import { PropsWithChildren, ReactElement } from 'react';

import ErrorIcon from '@mui/icons-material/Error';
import RefreshIcon from '@mui/icons-material/Refresh';
import { Box, IconButton, Stack, Typography } from '@mui/material';
import { ErrorBoundary, ErrorBoundaryProps } from '@sentry/react';

import { AppError, logger } from '@/utils';

const Fallback = (): ReactElement => {
  const handleReload = (): void => location.reload();

  return (
    <Box
      width="100%"
      height="100vh"
      display="grid"
      color="GrayText"
      sx={{
        placeItems: 'center',
      }}
    >
      <Stack alignItems="center" spacing={4}>
        <ErrorIcon
          color="disabled"
          sx={{
            height: 164,
            width: 164,
          }}
        />

        <Stack spacing={2} alignItems="center">
          <Typography fontSize={36} fontWeight={500}>
            Oops! Something went wrong.
          </Typography>

          <Typography>Try refreshing the page.</Typography>
        </Stack>

        <IconButton onClick={handleReload} color="inherit">
          <RefreshIcon />
        </IconButton>
      </Stack>
    </Box>
  );
};

export const AppErrorBoundary = (props: PropsWithChildren): ReactElement => {
  const handleError: ErrorBoundaryProps['onError'] = (error) => {
    if (error instanceof AppError) return logger.error(error.message);
    logger.error(error);
  };

  return (
    <ErrorBoundary fallback={Fallback} onError={handleError}>
      {props.children}
    </ErrorBoundary>
  );
};
